<template>
  <div class="d-flex-column gap-0 height-max-content top_navbar">
    <!-- TOP BAR -->
    <div class="d-flex-row space-between nav_items">
      <div
        class="d-flex-row gap-36 justify-start width-max-content main_navigation"
      >
        <NuxtLinkLocale to="/">
          <img
            src="/images/header-logo.webp"
            alt="header-logo"
            class="header-logo"
          />
        </NuxtLinkLocale>

        <div class="d-flex-row justify-start width-max-content gap-12">
          <NavOnlineBooster />

          <LangSelector />
          <GameSelector />
        </div>
      </div>
      <div
        class="d-flex-row justify-end width-max-content gap-12 navbar_navigation"
      >
        <NavbarNavigation v-if="!user.getUserLoggedIn" />
        <LoggedInNavigation
          v-else-if="user.getUserLoggedIn"
          :toggle-profile="toggleProfile"
          :open-profile="openProfile"
        />
      </div>
    </div>
    <GameTopTabs v-if="!$isMobile()" />
  </div>
</template>

<script setup>
import LangSelector from "../custom/LangSelector.vue";
import GameSelector from "../common/GameSelector.vue";
import NavbarNavigation from "./NavbarNavigation.vue";
import GameTopTabs from "../common/GameTopTabs.vue";
import LoggedInNavigation from "./LoggedInNavigation.vue";
import "../../assets/scss/_navbar.scss";
import NavOnlineBooster from "../common/NavOnlineBooster.vue";
const user = useUserStore();

defineProps({
  toggleProfile: {
    default: () => {},
  },
  openProfile: {
    default: () => {},
  },
});
</script>
